import splitbee from "@splitbee/web"
import React, { useEffect } from "react"
import posthog from 'posthog-js'

interface TrackersProps {
  isCookieEnabled: boolean
}

const Trackers = (props: TrackersProps) => {
  const { isCookieEnabled } = props;

  useEffect(() => {
    splitbee.init({ disableCookie: !isCookieEnabled });
    posthog.init('phc_sbjqqNoqn2i1uUihIUq1cfpbX34fWvpWsrU8IYdPDU5', {
      api_host: 'https://eu.i.posthog.com',
      person_profiles: 'always'
    });
    loadToltScript();

    if (isCookieEnabled) {
      loadTrackingScripts();
    }

  }, [isCookieEnabled]);

  const loadTrackingScripts = () => {
    loadGoogleScripts();
    loadGTMScripts();
  };

  const loadToltScript = () => {
    const toltScript = document.createElement('script');
    toltScript.src = 'https://cdn.tolt.io/tolt.js';
    toltScript.setAttribute('data-tolt', '19340b2b-e36e-4558-8627-54ac230aa3b8');
    document.body.appendChild(toltScript);
  };

  const loadGoogleScripts = () => {
    const gtagScript1 = document.createElement("script");
    gtagScript1.src = "https://www.googletagmanager.com/gtag/js?id=AW-11234356674";
    gtagScript1.async = true;
    document.body.appendChild(gtagScript1);

    const gtagScript2 = document.createElement("script");
    gtagScript2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments)}
      gtag("js", new Date());
      gtag('config', 'AW-11234356674');
    `;
    document.body.appendChild(gtagScript2);
  };

  const loadGTMScripts = () => {
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TRW4RS9V');
    `;
    document.body.appendChild(gtmScript);

    const gtmNoscript = document.createElement('noscript');
    gtmNoscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TRW4RS9V"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(gtmNoscript);
  };

  return null;
}

export default Trackers;
